export default "__VITE_ASSET__CwGCOuZY__"